import { ContentStateInterface } from '../../../../../../@types/types'
import { ConstructionConditionOption } from '../../../../../../@types/dropdown-types'
import { RealEstateInformation } from '../../../../../../@types/real-estate-api-types'
import { energyCertificateToApi } from './energyCertificateToApi'

export const informationToApi = (insertionData: ContentStateInterface): RealEstateInformation => {
  return {
    energyCertificate: energyCertificateToApi(insertionData),
    condition: insertionData.constructionCondition ?? ConstructionConditionOption.NO_INFORMATION,
    lastRefurbishment: insertionData.constructionLastModernization,
    constructionYear: insertionData.constructionYear,
    energyCertificateAvailability: insertionData.energyCertificateAvailability,
    ...(insertionData.unknownConstructionYear && {
      constructionYearUnknown: insertionData.unknownConstructionYear,
      constructionYear: undefined,
    }),
  }
}
